// inv/src/pages/solutions/established-businesses/blocks/EstablishedResearchSection.jsx
import { useTranslation } from 'react-i18next';
import CTAHover from '../../../../components/ui/CTAHover';
import { CheckCircle2 } from 'lucide-react';

const EstablishedResearchSection = ({ bgColor = 'bg-slate-50' }) => {
  const { t } = useTranslation();

  return (
    <section className={`py-16 sm:py-24 ${bgColor}`}>
      <div className="w-[75%] mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 gap-16 items-center">
        <div className="order-2 lg:order-1">
          <h3 className="text-2xl text-blue-600 font-bold mb-4">
            {t(
              'pageSolutions.EstablishedBusinesses.t11',
              'Turn opaque investor markets into clear signals'
            )}
          </h3>
          <h2 className="text-3xl sm:text-4xl font-semibold text-stone-900">
            {t(
              'pageSolutions.EstablishedBusinesses.t12',
              'Understand how capital providers invest in businesses like yours'
            )}
          </h2>

          <p className="mt-6 text-base leading-7 text-stone-700">
            {t(
              'pageSolutions.EstablishedBusinesses.t13',
              'Crino surfaces deal history, portfolio patterns and investor theses, so you negotiate from a position of insight — not guesswork.'
            )}
          </p>

          <ul className="mt-6 space-y-4 text-base leading-7 text-stone-700">
            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EstablishedBusinesses.t14',
                  'Review recent deals by revenue band, valuation range and stake size (minority vs majority).'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EstablishedBusinesses.t15',
                  'Identify patterns in sectors, business models and geographies where they repeatedly deploy capital.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EstablishedBusinesses.t16',
                  'Prepare data-driven outreach that references comparable portfolio companies and deal structures.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EstablishedBusinesses.t17',
                  'Quickly qualify whether a fund, family office or corporate investor aligns with your strategic goals.'
                )}
              </span>
            </li>
          </ul>

          <CTAHover
            className="mt-8"
            text={t(
              'pageSolutions.EstablishedBusinesses.t18',
              'Analyse investors for your next round'
            )}
            href="find-investors/"
            align="left"
            bgColor="bg-amber-300 text-stone-800"
            textColor="text-stone-800"
            hoverTextColor="text-stone-800"
          />
        </div>

        <div className="order-1 lg:order-2 mb-12 lg:mb-0">
          <img
            className="w-full"
            src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/solutions/crino-investor-funding-crm-system.png"
            alt={t(
              'pageSolutions.EstablishedBusinesses.alt2',
              'Deal history and investor profile dashboard for established businesses in Crino'
            )}
          />
        </div>
      </div>
    </section>
  );
};

export default EstablishedResearchSection;
